import { useNavigate } from "react-router-dom";
// ui
import { useStyletron } from 'baseui';
import { Block } from "baseui/block";
import { CurrentUserAvatar } from '../../components/User/CurrentUserAvatar'
import { NavigationButton } from '../../components/NavigationButton/NavigationButton'
// api
import logo from '../../logo.png'; // Tell webpack this JS file uses this image
import { IoHomeOutline, IoGridOutline,  IoLogoAppleAr, IoSettingsOutline } from 'react-icons/io5'
import { PLACEMENT, StatefulPopover } from 'baseui/popover';
import { StatefulMenu } from 'baseui/menu';
import { Button, KIND, SHAPE } from 'baseui/button';
import { apiConfig } from '../../config';
import { AlarmNavigationButton } from "../AlarmNavigationButton/AlarmNavigationButton";



export interface LeftMenuToolbarProps {
  onClicked?: any;
}

const LeftMenuToolbar = (props: LeftMenuToolbarProps) => {
  const [css, theme] = useStyletron();
  const nav = useNavigate();


  const onSelectMenuItem = (item: any, close: any) => {
    nav(item.url);
    close();
  }

  return (
    <Block height='100%' display='flex' flexDirection='column' justifyContent='space-between' alignItems='center' >
      <img src={logo} height={40} width={40} alt='logo' onClick={() => nav("/")}></img>
      <Block display='flex' flexDirection='column' justifyContent='center' alignItems='center' gridGap={theme.sizing.scale800}>

        <NavigationButton href='/objects' title='Objects'>
          <IoHomeOutline size='1.2em'></IoHomeOutline>
        </NavigationButton>
        <NavigationButton href='/dashboards' title='Dashboards' >
          <IoGridOutline size='1.2em'></IoGridOutline>
        </NavigationButton>

        <AlarmNavigationButton></AlarmNavigationButton>
        
        {apiConfig.isDevelopment &&
          <NavigationButton href='/bim' title='BIM' >
            <IoLogoAppleAr size='1.2em'> </IoLogoAppleAr>
          </NavigationButton>
        }
        <StatefulPopover
          focusLock
          placement={PLACEMENT.auto}
          content={({ close }) => (
            <StatefulMenu
              items={ITEMS}
              onItemSelect={(args) => { onSelectMenuItem(args.item, close) }}
              overrides={{
                //  List: {style: {height: '150px', width: '138px'}},
              }}
            />
          )}
        >
          <Button shape={SHAPE.circle} kind={KIND.tertiary}>
            <IoSettingsOutline size='1.2em'></IoSettingsOutline>
          </Button>
        </StatefulPopover>
      </Block>
      <CurrentUserAvatar></CurrentUserAvatar>
    </Block>
  )

}

const ITEMS = [
  { label: 'Alarm Classes', url: '/alarmClasses' },
  { label: 'Create Apps', url: '/addnewobjects' },
];


export default LeftMenuToolbar
